import { useState } from "react";
import "@google/model-viewer";

const Preview3D = ({data, counter}) => {
    const [previewURL, setPreviewURL] = useState(null);

    function createPreviewData(state) {
        var inner_profile = "";
        var outer_profile = "";
        var panel_profile = "";
        if (state.tool) {
            if (state.tool.usage) {
                if (state.tool.usage.inner) {
                    if (state.tool.usage.inner.enabled) {
                        inner_profile = state.tool.name;
                    }
                }
                if (state.tool.usage.outer) {
                    if (state.tool.usage.outer.enabled) {
                        outer_profile = state.tool.name;
                    }
                }
                if (state.tool.usage.raised) {
                    if (state.tool.usage.raised.enabled) {
                        panel_profile = state.tool.name;
                    }
                }
            }
        }
        var data = {
            width: 8.0,
            height: 8.0,
            frame_width: 1.5,
            inner_profile: inner_profile,
            panel_profile: panel_profile,
            outer_profile: outer_profile
        };
        return data;
    }

    function serializeForURL(obj) {
        var str = [];
        var params = {};
        for(var p in obj._defaults || [])
            params[p] = obj._defaults[p];
        for(var p in obj)
            params[p] = obj[p];
        console.log(params);
        for(var p in params)
           str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
    }
      
    function createPreviewURL(fmt, props, counter) {
        var prop_str = serializeForURL(props);
        return `${process.env.REACT_APP_API_URL}v1/3dpreview/preview?format=${fmt}&${prop_str}&dummy_counter=${counter}`;
    }

    return <model-viewer style={{width: 350, height: 350}}
        src={createPreviewURL("glb", createPreviewData(data), counter)}
        camera-controls
        camera-target={"0m 0m 0m"}
        camera-orbit={"35deg 98deg 100%"}
        disable-tap={true}
        shadow-intensity={1}
        touch-action={"pan-y"}
        environment-image={"https://cdn.shopify.com/s/files/1/0688/0641/0547/files/small.hdr"}
        exposure={2.2}
        tone-mapping={"commerce"}
    />;
}

export {Preview3D}
